(function () {
    'use strict';

    var $ = window.jQuery;
    var Waypoint = window.Waypoint;

    function InfiniteGloryPosts(options) {
        this.waypoint = null;
        this.waypointOptions = {};

        this.options = $.extend({}, InfiniteGloryPosts.defaults, options);

        if (!this.options.template) {
            throw new Error('Template does not set');
        }

        this.setupHandler();
    }

    /* Private */
    InfiniteGloryPosts.prototype.setupHandler = function () {
        var self = this,
            $glory_list = $('ul.bordeaux-glory-list'),
            categories = $glory_list.data('categories'),
            additional = '';
        self.offset = $glory_list.find('li').length;

        if (self.waypoint) {
            self.waypoint.destroy();
        }

        if (categories) {
            for (var i = 0; i < categories.length; i++) {
                additional += '&categories[]=' + categories[i];
            }
        }

        if (!$glory_list.length) {
            return;
        }

        self.waypointOptions = {
            element: $glory_list.get(0),
            handler: function (direction) {
                $.ajax({
                    url: '/wp-json/arkansas/v2/glory_posts?limit=' + self.options.limit + '&offset=' + self.options.offset + additional,
                    type: 'GET',
                    success: function (data) {
                        firePageView();
                        if (data.length) {
                            self.options.offset += data.length;
                            $.each(data, function (k, v) {
                                $glory_list.append(self.options.template(v));
                            });
                            self.setupHandler();
                        }
                    }
                });
            },
            offset: 'bottom-in-view'
        };

        self.waypoint = new Waypoint(self.waypointOptions);
    };

    InfiniteGloryPosts.defaults = {
        offset: 0,
        limit: 8,
    };

    window.InfiniteGloryPosts = InfiniteGloryPosts;
}());